export default __webpack_public_path__ + "static/media/calcium.45a38296.jpg";